import { AppShell } from '../../components/AppShell/AppShell';
import { Footer } from '../../components/Footer/Footer';
import { Container } from 'react-bootstrap';
import { Title } from '../../components/Title/Title';
import { useTranslation } from 'react-i18next';
import styles from './Company.module.scss';

const CompanyComponent = () => {
  const { t } = useTranslation();

  return (
    <AppShell>
      <div className={styles.page}>
        <Title>{t('legalese.labels.informazioniSocietarie')}</Title>

        <Container className={styles.content}>
          <div className={'d-flex align-items-center'}>
            <h1 className="text-page-title">{t('legalese.labels.informazioniSocietarie')}</h1>
          </div>
          <div className='mt-5'>
            <strong>EXAFLIX SRL</strong> <br />
            Rovigo (RO) <br />
            Via Alessandro Casalini 9 - CAP 45100 <br />
            Codice fiscale e Partita Iva n. 01671630299 <br />
            Registro delle Imprese di VENEZIA ROVIGO <br />
            Data iscrizione: 21/02/2025 <br />
            Numero REA RO - 462642 <br />
            Capitale sociale 10.000,00 (interamente versato)
          </div>
        </Container>

        <Footer />
      </div>
    </AppShell>
  );
};

export default CompanyComponent;
